import { render, staticRenderFns } from "./bodyRightBottom.vue?vue&type=template&id=43f52c64&scoped=true"
import script from "./bodyRightBottom.vue?vue&type=script&lang=js"
export * from "./bodyRightBottom.vue?vue&type=script&lang=js"
import style0 from "./bodyRightBottom.vue?vue&type=style&index=0&id=43f52c64&prod&lang=scss&scoped=true"
import style1 from "./bodyRightBottom.vue?vue&type=style&index=1&id=43f52c64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f52c64",
  null
  
)

export default component.exports